import User from '@/types/auth/User';
import { ActionContext } from 'vuex';
import { UserState } from './types';

export default {
  setUser(store: ActionContext<UserState, any>, user: User): void {
    store.commit('setUser', user);
  }
};
